import { type ListItemButtonProps, ListItemButton } from '@mui/material'
import { useLink } from '@refinedev/core'

interface NavItemLinkProps extends ListItemButtonProps {
  to: string
  selected?: boolean
}

export const NavItemLink = ({ to, ...props }: NavItemLinkProps) => {
  const Link = useLink()
  return (
    <ListItemButton
      component={Link}
      to={to}
      sx={{
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        '&.Mui-selected': {
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'transparent',
        },
      }}
      {...props}
    />
  )
}
